import { Session } from "next-auth";
import GoogleProvider from "next-auth/providers/google";
import { JWT } from "next-auth/jwt";
import { AdapterUser } from "next-auth/adapters";
import type { NextAuthConfig } from "next-auth";
import type { NextApiRequest, NextApiResponse } from "next";

export interface ExtendedUser extends AdapterUser {
  role?: string;
  plan?: string;
  familyName: string;
  givenName: string;
  name: string; // Ensure name is always a string
  image: string; // Ensure image is always a string
}

export interface ExtendedSession extends Session {
  user: ExtendedUser;
}

export interface ExtendedToken extends JWT {
  role?: string;
  plan?: string;
  familyName: string;
  givenName: string;
}
export type CombineRequest = Request &
  NextApiRequest & { auth?: ExtendedSession };
export type CombineResponse = Response & NextApiResponse;

export default {
  trustHost: true,
  providers: [
    GoogleProvider({
      clientId: process.env.GOOGLE_CLIENT_ID,
      clientSecret: process.env.GOOGLE_CLIENT_SECRET,
    }),
  ],
  callbacks: {
    async signIn() {
      // user, account, profile, email, credentials
      //console.log('@CALLBACK signIn user', user);
      //console.log('@CALLBACK signIn account', account);
      //console.log("@CALLBACK signIn profile", profile);
      //console.log('@CALLBACK signIn email', email);
      //console.log('@CALLBACK signIn credentials', credentials);
      return true;
    },
    async redirect({ baseUrl }) {
      return baseUrl;
    },
    async session({ session, token }) {
      // user
      return { ...session, token: token };
      /*
        let dbUser = await prisma.user.findUnique({ where: { email: token.email as string } })
        if(dbUser){
          console.log('@CALLBACK session dbUser', dbUser)
          return {
            user: dbUser
          }
        } else {
          session.user.givenName = token.givenName;
          session.user.familyName = token.familyName;
          console.log('@CALLBACK session ', session)
          return session;
        }*/
      /*
        console.log('@CALLBACK session session', session);
        console.log('@CALLBACK session user', user);
        console.log('@CALLBACK session token', token);
        //console.log('@CALLBACK session user', user);
        //console.log('@CALLBACK session token', token);
       
        let newSession = {
          user: session.user
        } as ExtendedSession;
        
        if(session){
          if (session.user) {
            let dbUser = await prisma.user.findUnique({ where: { email: token.email as string } })
            if (dbUser) {
              newSession.user.id = dbUser.id;
              newSession.user.role = dbUser?.role as string;
              newSession.user.plan = dbUser?.plan as string;
              if(token){
                newSession.user.familyName = token.familyName as string;
                newSession.user.givenName = token.givenName as string;
              }
              console.log('@CALLBACK session newSession', newSession)
              return newSession;

            } else {
              return token;
            }
          }
        } else {
          return null;
        }*/
    },
    async jwt({ token, profile }) {
      //console.log("@CALLBACK jwt token", token);
      //console.log('@CALLBACK jwt user', user)
      //console.log('@CALLBACK jwt account', account)
      //console.log('@CALLBACK jwt profile', profile)
      //console.log('@CALLBACK jwt isNewUser', isNewUser)
      if (profile) {
        token.givenName = profile.given_name;
        token.familyName = profile.family_name;
        token.role = profile.role;
      }

      return token;
    },
  },
  pages: {
    signIn: "/login",
  },
  secret: process.env.AUTH_SECRET,
} satisfies NextAuthConfig;
